"use strict";
/*
 * Membrane React package
 * {@link https://www.npmjs.com/package/@membranehq/react}
 * v0.29.2
 */
'use client';

import { jsx } from 'react/jsx-runtime';

function NoUiFormula() {
  return /* @__PURE__ */ jsx("span", { children: "This value cannot be displayed" });
}

export { NoUiFormula as default };
